import { Pathable, FormLens, useZoom, PathSelector } from "@tdp/common/form";

/**
 * "lifts" a hook that works atop a lens for a specified type into a factory that creates lenses for the specified type by id 
 * from the form data. 
 * 
 * E.G. useStringLength<Lens<string>> can be converted into createStringLengthHook which will allow for the developer to specify a path
 * from a root 'object' to a string property and get a hook that will return the string length for that property when given the entity's id.
 * @param lensFn The function providing the base type by id (E.G. get app by for app id)
 * @param hook The hook that works atop a lens (E.G. useStringLength)
 * @returns a hook factory that returns a unique hook for the specified property under the root entity.
 */
export function liftLensHook<TEntity extends Pathable, TLeaf, THookResult, IHookOptions = object>(
  lensFn: (id: string) => FormLens<TEntity>,
  //mmmm hook for reading the tea... i mean TLeafs
  hook: (lens: FormLens<TLeaf>, options: IHookOptions) => THookResult) {
  return function createHook(selectorFn: PathSelector<TEntity, TLeaf>, options: IHookOptions) {
    return function useFormFieldPropsForEntity(id: string) {
      const entityLens = lensFn(id); // get the entity
      const targetLens = useZoom(entityLens, selectorFn); // get the leaf value
      return hook(targetLens, options);
    }
  }
}
